// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ink: #101522;
  --muted: #687085;
  --line: rgba(16, 21, 34, 0.12);
  --panel: rgba(255, 255, 255, 0.8);
  --accent: #18a4a6;
  --accent-dark: #0e737a;
  --coral: #ff6f61;
  --gold: #f4b24f;
  --surface: #f7f9fc;
  --shadow: 0 24px 70px rgba(20, 31, 48, 0.16);
}

* {
  box-sizing: border-box;
}

body {
  background:
    radial-gradient(circle at 8% 15%, rgba(24, 164, 166, 0.13), transparent 30%),
    radial-gradient(circle at 86% 12%, rgba(255, 111, 97, 0.13), transparent 26%),
    linear-gradient(135deg, #f8fbff 0%, #eef4f7 50%, #fff8ef 100%);
  color: var(--ink);
  min-height: 100vh;
}

button,
input {
  font: inherit;
}

.app-shell {
  min-height: 100vh;
  overflow-x: hidden;
}

.topbar {
  align-items: center;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1180px;
  padding: 22px 24px 0;
}

.topbar img {
  height: 82px;
  max-width: 390px;
  object-fit: contain;
}

.topbar span {
  border: 1px solid var(--line);
  border-radius: 999px;
  color: var(--muted);
  font-size: 0.86rem;
  padding: 9px 14px;
}

.hero-shell,
.viewer-result,
.comparison-section,
.asset-reference {
  margin: 0 auto;
  max-width: 1180px;
  padding: 36px 24px;
}

.hero-shell {
  align-items: center;
  display: grid;
  gap: 30px;
  grid-template-columns: minmax(0, 0.95fr) minmax(360px, 1.05fr);
}

.hero-copy h1,
.viewer-copy h1,
.processing-card h1 {
  font-size: clamp(1.55rem, 3vw, 2.45rem);
  line-height: 1.12;
  margin: 0;
  max-width: 620px;
}

.processing-card h1,
.section-heading h2 {
  font-size: clamp(1.35rem, 2.5vw, 2rem);
  line-height: 1.18;
}

.hero-copy p,
.viewer-copy p,
.section-heading p {
  color: var(--muted);
  font-size: 0.94rem;
  line-height: 1.55;
  max-width: 560px;
}

.eyebrow {
  color: var(--accent-dark);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0;
  margin: 0 0 16px;
  text-transform: uppercase;
}

.upload-panel,
.processing-card,
.comparison-card,
.slider-card,
.asset-pair,
.viewer-shell {
  background: var(--panel);
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: var(--shadow);
  backdrop-filter: blur(20px);
}

.upload-panel {
  border-radius: 26px;
  padding: 22px;
  transition: border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease;
}

.sample-panel {
  background: #060b1d;
  border-color: rgba(121, 139, 180, 0.18);
  box-shadow: 0 24px 80px rgba(6, 11, 29, 0.28);
}

.upload-panel.is-dragging {
  border-color: rgba(24, 164, 166, 0.7);
  box-shadow: 0 28px 90px rgba(24, 164, 166, 0.22);
  transform: translateY(-2px);
}

.upload-content {
  align-items: center;
  border: 1px dashed rgba(14, 115, 122, 0.36);
  border-radius: 18px;
  display: grid;
  gap: 18px;
  justify-items: center;
  min-height: 330px;
  padding: 32px;
  text-align: center;
}

.upload-content h2 {
  font-size: clamp(1.45rem, 3vw, 2.05rem);
  margin: 0 0 8px;
}

.upload-content p {
  color: var(--muted);
  margin: 0;
}

.sample-dropzone {
  align-items: center;
  background: transparent;
  border: 2px dashed rgba(121, 139, 180, 0.24);
  border-radius: 18px;
  color: #eef5ff;
  cursor: pointer;
  display: grid;
  gap: 13px;
  justify-items: center;
  min-height: 290px;
  padding: 22px;
  text-align: center;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
  width: 100%;
}

.sample-dropzone:hover,
.sample-dropzone:focus-visible {
  border-color: rgba(24, 164, 166, 0.62);
  box-shadow: inset 0 0 0 1px rgba(24, 164, 166, 0.18);
}

.sample-dropzone.is-selected {
  border-color: var(--accent);
  box-shadow:
    inset 0 0 0 1px rgba(24, 164, 166, 0.28),
    0 18px 44px rgba(24, 164, 166, 0.18);
}

.sample-dropzone img {
  background: #34383b;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  max-height: 205px;
  max-width: min(230px, 76vw);
  object-fit: contain;
  padding: 8px;
}

.sample-dropzone strong {
  font-size: 0.92rem;
}

.sample-dropzone span:last-child {
  color: #b8cff0;
  font-size: 0.8rem;
}

.upload-icon {
  align-items: center;
  background: #111849;
  border-radius: 12px;
  color: #dce8ff;
  display: flex;
  font-size: 1.15rem;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.upload-orb {
  align-items: center;
  background: linear-gradient(145deg, var(--accent), var(--coral));
  border-radius: 999px;
  color: white;
  display: flex;
  font-size: 2.4rem;
  font-weight: 300;
  height: 86px;
  justify-content: center;
  width: 86px;
}

#image-upload {
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.button {
  align-items: center;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  font-weight: 800;
  justify-content: center;
  min-height: 48px;
  padding: 0 22px;
  text-decoration: none;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.button:focus-visible,
.modal-close:focus-visible,
.viewer360:focus-visible,
.viewer-controls button:focus-visible,
input[type='range']:focus-visible {
  outline: 3px solid rgba(244, 178, 79, 0.68);
  outline-offset: 3px;
}

.button:hover,
.viewer-controls button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  transform: none;
}

.primary-button {
  background: linear-gradient(135deg, #16c8c3, #f4b24f);
  box-shadow: 0 18px 42px rgba(24, 164, 166, 0.32);
  color: #061018;
  margin-top: 18px;
  width: 100%;
}

.sample-panel .primary-button:not(:disabled) {
  background: linear-gradient(135deg, #22e1d6 0%, #ffd36f 100%);
  box-shadow:
    0 18px 44px rgba(34, 225, 214, 0.28),
    0 0 0 1px rgba(255, 255, 255, 0.35) inset;
  color: white;
  color: #031014;
}

.sample-panel .primary-button:not(:disabled):hover {
  box-shadow:
    0 22px 54px rgba(34, 225, 214, 0.38),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
}

.sample-panel .primary-button:disabled {
  background: rgba(255, 255, 255, 0.14);
  box-shadow: none;
  color: rgba(238, 245, 255, 0.52);
  margin-top: 18px;
  width: 100%;
}

.secondary-button {
  background: white;
  border: 1px solid var(--line);
  color: var(--ink);
}

.preview-strip {
  align-items: center;
  background: white;
  border-radius: 16px;
  display: flex;
  gap: 14px;
  margin-top: 16px;
  padding: 12px;
}

.preview-strip img {
  border-radius: 12px;
  height: 72px;
  object-fit: cover;
  width: 72px;
}

.preview-strip div {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.preview-strip strong,
.preview-strip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-strip span,
.error-message {
  color: var(--muted);
  font-size: 0.92rem;
}

.error-message {
  background: rgba(255, 111, 97, 0.12);
  border: 1px solid rgba(255, 111, 97, 0.22);
  border-radius: 12px;
  color: #9d3028;
  padding: 12px 14px;
}

.processing-view {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 90px);
  padding: 32px 24px;
}

.processing-card {
  border-radius: 28px;
  max-width: 760px;
  padding: clamp(28px, 5vw, 56px);
  width: 100%;
}

.loader-ring {
  animation: spin 1.2s linear infinite;
  border: 4px solid rgba(24, 164, 166, 0.14);
  border-left-color: var(--accent);
  border-radius: 999px;
  height: 64px;
  margin-bottom: 24px;
  width: 64px;
}

.progress-meta {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 34px;
}

.progress-track {
  background: rgba(16, 21, 34, 0.1);
  border-radius: 999px;
  height: 12px;
  margin-top: 12px;
  overflow: hidden;
}

.progress-track div {
  background: linear-gradient(90deg, var(--accent), var(--gold), var(--coral));
  border-radius: inherit;
  height: 100%;
  transition: width 160ms ease;
}

.stage-list {
  display: grid;
  gap: 12px;
  list-style: none;
  margin: 28px 0 0;
  padding: 0;
}

.stage-list li {
  align-items: center;
  color: var(--muted);
  display: flex;
  gap: 10px;
  transition: color 180ms ease, transform 180ms ease;
}

.stage-list span {
  align-items: center;
  background: rgba(16, 21, 34, 0.08);
  border-radius: 999px;
  display: flex;
  font-size: 0.82rem;
  height: 26px;
  justify-content: center;
  width: 26px;
}

.stage-list .is-active {
  color: var(--ink);
  transform: translateX(4px);
}

.stage-list .is-active span {
  background: var(--accent);
  color: white;
}

.result-page {
  padding-bottom: 48px;
}

.viewer-result {
  display: grid;
  gap: 20px;
}

.viewer-copy {
  display: grid;
  gap: 10px;
  justify-items: start;
}

.viewer-copy p {
  margin: 0;
}

.viewer-shell {
  border-radius: 28px;
  padding: clamp(14px, 2vw, 20px);
}

.viewer360 {
  align-items: center;
  background:
    radial-gradient(circle at 50% 28%, rgba(255, 255, 255, 0.85), transparent 32%),
    linear-gradient(145deg, #111820, #273745 58%, #182329);
  border-radius: 22px;
  cursor: grab;
  display: flex;
  justify-content: center;
  min-height: clamp(440px, 62vw, 720px);
  overflow: hidden;
  perspective: 1180px;
  position: relative;
  touch-action: pan-y;
  -webkit-user-select: none;
          user-select: none;
}

.viewer360.is-dragging {
  cursor: grabbing;
  touch-action: none;
}

.viewer360.is-fullscreen {
  border-radius: 0;
  min-height: 100vh;
}

.viewer-world {
  align-items: center;
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
  transform-style: preserve-3d;
}

.demo-360-object {
  height: clamp(220px, 34vw, 380px);
  position: relative;
  transform-style: preserve-3d;
  width: clamp(220px, 34vw, 380px);
  will-change: transform;
}

.demo-face,
.demo-depth-rib {
  backface-visibility: hidden;
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: inset 0 0 30px rgba(255, 255, 255, 0.08);
  position: absolute;
}

.demo-face-front,
.demo-face-back {
  align-items: center;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(233, 227, 210, 0.94));
  border-radius: 18px;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  top: 0;
  width: 100%;
}

.demo-face-front {
  transform: translateZ(72px);
}

.demo-face-front img {
  filter: drop-shadow(0 18px 24px rgba(18, 24, 34, 0.28));
  height: 92%;
  object-fit: contain;
  width: 92%;
}

.demo-face-back {
  color: rgba(16, 21, 34, 0.3);
  font-size: clamp(3rem, 9vw, 7rem);
  font-weight: 900;
  transform: rotateY(180deg) translateZ(72px);
}

.demo-face-right,
.demo-face-left {
  background: linear-gradient(180deg, #d8d1bb, #9d9177);
  border-radius: 16px;
  height: 100%;
  top: 0;
  width: 144px;
}

.demo-face-right {
  right: -72px;
  transform: rotateY(90deg);
}

.demo-face-left {
  left: -72px;
  transform: rotateY(-90deg);
}

.demo-face-top,
.demo-face-bottom {
  background: linear-gradient(90deg, #f7f0dd, #beb393);
  border-radius: 16px;
  height: 144px;
  left: 0;
  width: 100%;
}

.demo-face-top {
  top: -72px;
  transform: rotateX(90deg);
}

.demo-face-bottom {
  bottom: -72px;
  transform: rotateX(-90deg);
}

.demo-depth-rib {
  background: rgba(24, 164, 166, 0.2);
  border-radius: 999px;
  height: 76%;
  left: 50%;
  top: 12%;
  transform: translateX(-50%) translateZ(86px);
  width: 18px;
}

.rib-two {
  left: 26%;
  transform: translateX(-50%) rotateY(22deg) translateZ(96px);
}

.rib-three {
  left: 74%;
  transform: translateX(-50%) rotateY(-22deg) translateZ(96px);
}

.viewer-ground-shadow {
  background: radial-gradient(ellipse, rgba(0, 0, 0, 0.46), transparent 68%);
  bottom: 13%;
  height: 90px;
  left: 25%;
  position: absolute;
  transform: rotateX(74deg);
  width: 50%;
}

.viewer-badge,
.viewer-help {
  border-radius: 999px;
  font-weight: 800;
  position: absolute;
  z-index: 3;
}

.viewer-badge {
  background: linear-gradient(135deg, var(--accent), var(--gold));
  color: #071016;
  left: 18px;
  padding: 9px 12px;
  top: 18px;
}

.viewer-help {
  background: rgba(255, 255, 255, 0.86);
  bottom: 18px;
  color: var(--ink);
  left: 50%;
  padding: 10px 14px;
  transform: translateX(-50%);
}

.viewer-loading {
  align-items: center;
  background: rgba(7, 11, 18, 0.84);
  color: white;
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
  z-index: 4;
}

.viewer-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding-top: 16px;
}

.viewer-controls button,
.zoom-readout {
  align-items: center;
  background: white;
  border: 1px solid var(--line);
  border-radius: 999px;
  color: var(--ink);
  display: inline-flex;
  font-weight: 800;
  justify-content: center;
  min-height: 42px;
  min-width: 42px;
  padding: 0 15px;
  transition: transform 160ms ease, background 160ms ease;
}

.viewer-controls button {
  cursor: pointer;
}

.viewer-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.zoom-readout {
  color: var(--muted);
  min-width: 70px;
}

.viewer-notice {
  background: rgba(244, 178, 79, 0.14);
  border: 1px solid rgba(244, 178, 79, 0.32);
  border-radius: 16px;
  color: #6c4a11;
  line-height: 1.55;
  margin: 16px 0 0;
  padding: 13px 15px;
}

.upload-another {
  justify-self: center;
  max-width: 280px;
}

.model-viewer-shell {
  background:
    radial-gradient(circle at 50% 18%, rgba(24, 164, 166, 0.12), transparent 34%),
    linear-gradient(145deg, #ffffff, #f4f7fb 58%, #eef3f7);
  border: 1px solid rgba(16, 21, 34, 0.1);
  border-radius: 28px;
  box-shadow: var(--shadow);
  min-height: clamp(520px, 68vw, 760px);
  overflow: hidden;
  position: relative;
}

.model-viewer-shell.is-fullscreen {
  border-radius: 0;
  min-height: 100vh;
}

.model-suspense,
.model-loading {
  align-items: center;
  color: var(--ink);
  display: flex;
  font-weight: 800;
  justify-content: center;
}

.model-canvas {
  height: clamp(520px, 68vw, 760px);
  position: relative;
  width: 100%;
}

.model-canvas canvas {
  display: block;
  height: 100%;
  width: 100%;
}

.model-badge,
.model-helper {
  border-radius: 999px;
  font-weight: 800;
  position: absolute;
  z-index: 3;
}

.model-badge {
  background: linear-gradient(135deg, var(--accent), var(--gold));
  color: #071016;
  left: 18px;
  padding: 9px 12px;
  top: 18px;
}

.model-helper {
  background: rgba(255, 255, 255, 0.88);
  bottom: 18px;
  color: var(--ink);
  left: 50%;
  padding: 10px 14px;
  transform: translateX(-50%);
}

.model-loading {
  background: rgba(255, 255, 255, 0.76);
  flex-direction: column;
  gap: 8px;
  inset: 0;
  position: absolute;
  z-index: 4;
}

.model-error {
  color: #9d3028;
  padding: 24px;
  text-align: center;
}

.model-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  left: 0;
  padding: 0 18px;
  position: absolute;
  right: 0;
  top: 18px;
  z-index: 5;
}

.model-controls button {
  align-items: center;
  background: #05070d;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-weight: 800;
  justify-content: center;
  min-height: 40px;
  min-width: 40px;
  padding: 0 14px;
}

.model-controls button:hover {
  background: #151a24;
}

.section-heading {
  margin-bottom: 26px;
}

.section-heading h2 {
  margin: 0;
  max-width: 780px;
}

.comparison-grid,
.asset-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.comparison-card,
.slider-card,
.asset-pair {
  border-radius: 22px;
  padding: 18px;
}

.comparison-card span,
.asset-pair span {
  color: var(--muted);
  display: block;
  font-weight: 800;
  margin-bottom: 12px;
}

.comparison-card img {
  aspect-ratio: 1 / 1;
  background: #20252c;
  border-radius: 16px;
  object-fit: contain;
  width: 100%;
}

.slider-card {
  margin: 20px 0;
}

.comparison-slider {
  aspect-ratio: 16 / 10;
  background: #141923;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
}

.comparison-slider img {
  height: 100%;
  object-fit: contain;
  padding: 20px;
  width: 100%;
}

.before-layer {
  background: #45484b;
  clip-path: inset(0 calc(100% - var(--split)) 0 0);
  inset: 0;
  position: absolute;
}

.before-label,
.after-label {
  background: rgba(255, 255, 255, 0.82);
  border-radius: 999px;
  color: var(--ink);
  font-size: 0.8rem;
  font-weight: 800;
  padding: 7px 10px;
  position: absolute;
  top: 14px;
}

.before-label {
  left: 14px;
}

.after-label {
  right: 14px;
}

input[type='range'] {
  accent-color: var(--accent);
  margin-top: 16px;
  width: 100%;
}

.asset-pair div {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
}

.asset-pair img {
  aspect-ratio: 1 / 1;
  background: #33373c;
  border-radius: 14px;
  object-fit: contain;
  padding: 8px;
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}

@media (max-width: 900px) {
  .hero-shell,
  .comparison-grid,
  .asset-grid {
    grid-template-columns: 1fr;
  }

  .viewer360 {
    min-height: 520px;
  }
}

@media (max-width: 560px) {
  .topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .topbar img {
    height: 70px;
    max-width: min(320px, 100%);
  }

  .hero-shell,
  .viewer-result,
  .comparison-section,
  .asset-reference {
    padding: 38px 16px;
  }

  .upload-content {
    min-height: 300px;
    padding: 24px 16px;
  }

  .preview-strip {
    align-items: flex-start;
  }

  .viewer360 {
    min-height: 430px;
  }

  .viewer-help {
    bottom: 14px;
    font-size: 0.86rem;
    max-width: calc(100% - 32px);
    text-align: center;
    width: max-content;
  }

  .asset-pair div {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;kEAGgE;EAChE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8DAA8D;AAChE;;AAEA;;;EAGE,uCAAuC;EACvC,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,wBAAwB;EACxB,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gFAAgF;EAChF,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B;;wCAEsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gEAAgE;EAChE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8EAA8E;AAChF;;AAEA;;;;;EAKE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;EAChD,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D;;6CAE2C;EAC3C,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;;4CAE0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB;;0DAEwD;EACxD,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,2CAA2C;EAC3C,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,yFAAyF;EACzF,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,oDAAoD;EACpD,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,0EAA0E;EAC1E,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+DAA+D;EAC/D,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;;0DAEwD;EACxD,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+DAA+D;EAC/D,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;EACxC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\n  --ink: #101522;\n  --muted: #687085;\n  --line: rgba(16, 21, 34, 0.12);\n  --panel: rgba(255, 255, 255, 0.8);\n  --accent: #18a4a6;\n  --accent-dark: #0e737a;\n  --coral: #ff6f61;\n  --gold: #f4b24f;\n  --surface: #f7f9fc;\n  --shadow: 0 24px 70px rgba(20, 31, 48, 0.16);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  background:\n    radial-gradient(circle at 8% 15%, rgba(24, 164, 166, 0.13), transparent 30%),\n    radial-gradient(circle at 86% 12%, rgba(255, 111, 97, 0.13), transparent 26%),\n    linear-gradient(135deg, #f8fbff 0%, #eef4f7 50%, #fff8ef 100%);\n  color: var(--ink);\n  min-height: 100vh;\n}\n\nbutton,\ninput {\n  font: inherit;\n}\n\n.app-shell {\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n.topbar {\n  align-items: center;\n  display: flex;\n  gap: 14px;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 22px 24px 0;\n}\n\n.topbar img {\n  height: 82px;\n  max-width: 390px;\n  object-fit: contain;\n}\n\n.topbar span {\n  border: 1px solid var(--line);\n  border-radius: 999px;\n  color: var(--muted);\n  font-size: 0.86rem;\n  padding: 9px 14px;\n}\n\n.hero-shell,\n.viewer-result,\n.comparison-section,\n.asset-reference {\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 36px 24px;\n}\n\n.hero-shell {\n  align-items: center;\n  display: grid;\n  gap: 30px;\n  grid-template-columns: minmax(0, 0.95fr) minmax(360px, 1.05fr);\n}\n\n.hero-copy h1,\n.viewer-copy h1,\n.processing-card h1 {\n  font-size: clamp(1.55rem, 3vw, 2.45rem);\n  line-height: 1.12;\n  margin: 0;\n  max-width: 620px;\n}\n\n.processing-card h1,\n.section-heading h2 {\n  font-size: clamp(1.35rem, 2.5vw, 2rem);\n  line-height: 1.18;\n}\n\n.hero-copy p,\n.viewer-copy p,\n.section-heading p {\n  color: var(--muted);\n  font-size: 0.94rem;\n  line-height: 1.55;\n  max-width: 560px;\n}\n\n.eyebrow {\n  color: var(--accent-dark);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  margin: 0 0 16px;\n  text-transform: uppercase;\n}\n\n.upload-panel,\n.processing-card,\n.comparison-card,\n.slider-card,\n.asset-pair,\n.viewer-shell {\n  background: var(--panel);\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  box-shadow: var(--shadow);\n  backdrop-filter: blur(20px);\n}\n\n.upload-panel {\n  border-radius: 26px;\n  padding: 22px;\n  transition: border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease;\n}\n\n.sample-panel {\n  background: #060b1d;\n  border-color: rgba(121, 139, 180, 0.18);\n  box-shadow: 0 24px 80px rgba(6, 11, 29, 0.28);\n}\n\n.upload-panel.is-dragging {\n  border-color: rgba(24, 164, 166, 0.7);\n  box-shadow: 0 28px 90px rgba(24, 164, 166, 0.22);\n  transform: translateY(-2px);\n}\n\n.upload-content {\n  align-items: center;\n  border: 1px dashed rgba(14, 115, 122, 0.36);\n  border-radius: 18px;\n  display: grid;\n  gap: 18px;\n  justify-items: center;\n  min-height: 330px;\n  padding: 32px;\n  text-align: center;\n}\n\n.upload-content h2 {\n  font-size: clamp(1.45rem, 3vw, 2.05rem);\n  margin: 0 0 8px;\n}\n\n.upload-content p {\n  color: var(--muted);\n  margin: 0;\n}\n\n.sample-dropzone {\n  align-items: center;\n  background: transparent;\n  border: 2px dashed rgba(121, 139, 180, 0.24);\n  border-radius: 18px;\n  color: #eef5ff;\n  cursor: pointer;\n  display: grid;\n  gap: 13px;\n  justify-items: center;\n  min-height: 290px;\n  padding: 22px;\n  text-align: center;\n  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n  width: 100%;\n}\n\n.sample-dropzone:hover,\n.sample-dropzone:focus-visible {\n  border-color: rgba(24, 164, 166, 0.62);\n  box-shadow: inset 0 0 0 1px rgba(24, 164, 166, 0.18);\n}\n\n.sample-dropzone.is-selected {\n  border-color: var(--accent);\n  box-shadow:\n    inset 0 0 0 1px rgba(24, 164, 166, 0.28),\n    0 18px 44px rgba(24, 164, 166, 0.18);\n}\n\n.sample-dropzone img {\n  background: #34383b;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  max-height: 205px;\n  max-width: min(230px, 76vw);\n  object-fit: contain;\n  padding: 8px;\n}\n\n.sample-dropzone strong {\n  font-size: 0.92rem;\n}\n\n.sample-dropzone span:last-child {\n  color: #b8cff0;\n  font-size: 0.8rem;\n}\n\n.upload-icon {\n  align-items: center;\n  background: #111849;\n  border-radius: 12px;\n  color: #dce8ff;\n  display: flex;\n  font-size: 1.15rem;\n  height: 36px;\n  justify-content: center;\n  width: 36px;\n}\n\n.upload-orb {\n  align-items: center;\n  background: linear-gradient(145deg, var(--accent), var(--coral));\n  border-radius: 999px;\n  color: white;\n  display: flex;\n  font-size: 2.4rem;\n  font-weight: 300;\n  height: 86px;\n  justify-content: center;\n  width: 86px;\n}\n\n#image-upload {\n  height: 1px;\n  opacity: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.button {\n  align-items: center;\n  border: 0;\n  border-radius: 999px;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 800;\n  justify-content: center;\n  min-height: 48px;\n  padding: 0 22px;\n  text-decoration: none;\n  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.button:focus-visible,\n.modal-close:focus-visible,\n.viewer360:focus-visible,\n.viewer-controls button:focus-visible,\ninput[type='range']:focus-visible {\n  outline: 3px solid rgba(244, 178, 79, 0.68);\n  outline-offset: 3px;\n}\n\n.button:hover,\n.viewer-controls button:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.button:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  transform: none;\n}\n\n.primary-button {\n  background: linear-gradient(135deg, #16c8c3, #f4b24f);\n  box-shadow: 0 18px 42px rgba(24, 164, 166, 0.32);\n  color: #061018;\n  margin-top: 18px;\n  width: 100%;\n}\n\n.sample-panel .primary-button:not(:disabled) {\n  background: linear-gradient(135deg, #22e1d6 0%, #ffd36f 100%);\n  box-shadow:\n    0 18px 44px rgba(34, 225, 214, 0.28),\n    0 0 0 1px rgba(255, 255, 255, 0.35) inset;\n  color: white;\n  color: #031014;\n}\n\n.sample-panel .primary-button:not(:disabled):hover {\n  box-shadow:\n    0 22px 54px rgba(34, 225, 214, 0.38),\n    0 0 0 1px rgba(255, 255, 255, 0.5) inset;\n}\n\n.sample-panel .primary-button:disabled {\n  background: rgba(255, 255, 255, 0.14);\n  box-shadow: none;\n  color: rgba(238, 245, 255, 0.52);\n  margin-top: 18px;\n  width: 100%;\n}\n\n.secondary-button {\n  background: white;\n  border: 1px solid var(--line);\n  color: var(--ink);\n}\n\n.preview-strip {\n  align-items: center;\n  background: white;\n  border-radius: 16px;\n  display: flex;\n  gap: 14px;\n  margin-top: 16px;\n  padding: 12px;\n}\n\n.preview-strip img {\n  border-radius: 12px;\n  height: 72px;\n  object-fit: cover;\n  width: 72px;\n}\n\n.preview-strip div {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n}\n\n.preview-strip strong,\n.preview-strip span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.preview-strip span,\n.error-message {\n  color: var(--muted);\n  font-size: 0.92rem;\n}\n\n.error-message {\n  background: rgba(255, 111, 97, 0.12);\n  border: 1px solid rgba(255, 111, 97, 0.22);\n  border-radius: 12px;\n  color: #9d3028;\n  padding: 12px 14px;\n}\n\n.processing-view {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: calc(100vh - 90px);\n  padding: 32px 24px;\n}\n\n.processing-card {\n  border-radius: 28px;\n  max-width: 760px;\n  padding: clamp(28px, 5vw, 56px);\n  width: 100%;\n}\n\n.loader-ring {\n  animation: spin 1.2s linear infinite;\n  border: 4px solid rgba(24, 164, 166, 0.14);\n  border-left-color: var(--accent);\n  border-radius: 999px;\n  height: 64px;\n  margin-bottom: 24px;\n  width: 64px;\n}\n\n.progress-meta {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 34px;\n}\n\n.progress-track {\n  background: rgba(16, 21, 34, 0.1);\n  border-radius: 999px;\n  height: 12px;\n  margin-top: 12px;\n  overflow: hidden;\n}\n\n.progress-track div {\n  background: linear-gradient(90deg, var(--accent), var(--gold), var(--coral));\n  border-radius: inherit;\n  height: 100%;\n  transition: width 160ms ease;\n}\n\n.stage-list {\n  display: grid;\n  gap: 12px;\n  list-style: none;\n  margin: 28px 0 0;\n  padding: 0;\n}\n\n.stage-list li {\n  align-items: center;\n  color: var(--muted);\n  display: flex;\n  gap: 10px;\n  transition: color 180ms ease, transform 180ms ease;\n}\n\n.stage-list span {\n  align-items: center;\n  background: rgba(16, 21, 34, 0.08);\n  border-radius: 999px;\n  display: flex;\n  font-size: 0.82rem;\n  height: 26px;\n  justify-content: center;\n  width: 26px;\n}\n\n.stage-list .is-active {\n  color: var(--ink);\n  transform: translateX(4px);\n}\n\n.stage-list .is-active span {\n  background: var(--accent);\n  color: white;\n}\n\n.result-page {\n  padding-bottom: 48px;\n}\n\n.viewer-result {\n  display: grid;\n  gap: 20px;\n}\n\n.viewer-copy {\n  display: grid;\n  gap: 10px;\n  justify-items: start;\n}\n\n.viewer-copy p {\n  margin: 0;\n}\n\n.viewer-shell {\n  border-radius: 28px;\n  padding: clamp(14px, 2vw, 20px);\n}\n\n.viewer360 {\n  align-items: center;\n  background:\n    radial-gradient(circle at 50% 28%, rgba(255, 255, 255, 0.85), transparent 32%),\n    linear-gradient(145deg, #111820, #273745 58%, #182329);\n  border-radius: 22px;\n  cursor: grab;\n  display: flex;\n  justify-content: center;\n  min-height: clamp(440px, 62vw, 720px);\n  overflow: hidden;\n  perspective: 1180px;\n  position: relative;\n  touch-action: pan-y;\n  user-select: none;\n}\n\n.viewer360.is-dragging {\n  cursor: grabbing;\n  touch-action: none;\n}\n\n.viewer360.is-fullscreen {\n  border-radius: 0;\n  min-height: 100vh;\n}\n\n.viewer-world {\n  align-items: center;\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  position: absolute;\n  transform-style: preserve-3d;\n}\n\n.demo-360-object {\n  height: clamp(220px, 34vw, 380px);\n  position: relative;\n  transform-style: preserve-3d;\n  width: clamp(220px, 34vw, 380px);\n  will-change: transform;\n}\n\n.demo-face,\n.demo-depth-rib {\n  backface-visibility: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  box-shadow: inset 0 0 30px rgba(255, 255, 255, 0.08);\n  position: absolute;\n}\n\n.demo-face-front,\n.demo-face-back {\n  align-items: center;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(233, 227, 210, 0.94));\n  border-radius: 18px;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  overflow: hidden;\n  top: 0;\n  width: 100%;\n}\n\n.demo-face-front {\n  transform: translateZ(72px);\n}\n\n.demo-face-front img {\n  filter: drop-shadow(0 18px 24px rgba(18, 24, 34, 0.28));\n  height: 92%;\n  object-fit: contain;\n  width: 92%;\n}\n\n.demo-face-back {\n  color: rgba(16, 21, 34, 0.3);\n  font-size: clamp(3rem, 9vw, 7rem);\n  font-weight: 900;\n  transform: rotateY(180deg) translateZ(72px);\n}\n\n.demo-face-right,\n.demo-face-left {\n  background: linear-gradient(180deg, #d8d1bb, #9d9177);\n  border-radius: 16px;\n  height: 100%;\n  top: 0;\n  width: 144px;\n}\n\n.demo-face-right {\n  right: -72px;\n  transform: rotateY(90deg);\n}\n\n.demo-face-left {\n  left: -72px;\n  transform: rotateY(-90deg);\n}\n\n.demo-face-top,\n.demo-face-bottom {\n  background: linear-gradient(90deg, #f7f0dd, #beb393);\n  border-radius: 16px;\n  height: 144px;\n  left: 0;\n  width: 100%;\n}\n\n.demo-face-top {\n  top: -72px;\n  transform: rotateX(90deg);\n}\n\n.demo-face-bottom {\n  bottom: -72px;\n  transform: rotateX(-90deg);\n}\n\n.demo-depth-rib {\n  background: rgba(24, 164, 166, 0.2);\n  border-radius: 999px;\n  height: 76%;\n  left: 50%;\n  top: 12%;\n  transform: translateX(-50%) translateZ(86px);\n  width: 18px;\n}\n\n.rib-two {\n  left: 26%;\n  transform: translateX(-50%) rotateY(22deg) translateZ(96px);\n}\n\n.rib-three {\n  left: 74%;\n  transform: translateX(-50%) rotateY(-22deg) translateZ(96px);\n}\n\n.viewer-ground-shadow {\n  background: radial-gradient(ellipse, rgba(0, 0, 0, 0.46), transparent 68%);\n  bottom: 13%;\n  height: 90px;\n  left: 25%;\n  position: absolute;\n  transform: rotateX(74deg);\n  width: 50%;\n}\n\n.viewer-badge,\n.viewer-help {\n  border-radius: 999px;\n  font-weight: 800;\n  position: absolute;\n  z-index: 3;\n}\n\n.viewer-badge {\n  background: linear-gradient(135deg, var(--accent), var(--gold));\n  color: #071016;\n  left: 18px;\n  padding: 9px 12px;\n  top: 18px;\n}\n\n.viewer-help {\n  background: rgba(255, 255, 255, 0.86);\n  bottom: 18px;\n  color: var(--ink);\n  left: 50%;\n  padding: 10px 14px;\n  transform: translateX(-50%);\n}\n\n.viewer-loading {\n  align-items: center;\n  background: rgba(7, 11, 18, 0.84);\n  color: white;\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  position: absolute;\n  z-index: 4;\n}\n\n.viewer-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.viewer-controls button,\n.zoom-readout {\n  align-items: center;\n  background: white;\n  border: 1px solid var(--line);\n  border-radius: 999px;\n  color: var(--ink);\n  display: inline-flex;\n  font-weight: 800;\n  justify-content: center;\n  min-height: 42px;\n  min-width: 42px;\n  padding: 0 15px;\n  transition: transform 160ms ease, background 160ms ease;\n}\n\n.viewer-controls button {\n  cursor: pointer;\n}\n\n.viewer-controls button:disabled {\n  cursor: not-allowed;\n  opacity: 0.48;\n}\n\n.zoom-readout {\n  color: var(--muted);\n  min-width: 70px;\n}\n\n.viewer-notice {\n  background: rgba(244, 178, 79, 0.14);\n  border: 1px solid rgba(244, 178, 79, 0.32);\n  border-radius: 16px;\n  color: #6c4a11;\n  line-height: 1.55;\n  margin: 16px 0 0;\n  padding: 13px 15px;\n}\n\n.upload-another {\n  justify-self: center;\n  max-width: 280px;\n}\n\n.model-viewer-shell {\n  background:\n    radial-gradient(circle at 50% 18%, rgba(24, 164, 166, 0.12), transparent 34%),\n    linear-gradient(145deg, #ffffff, #f4f7fb 58%, #eef3f7);\n  border: 1px solid rgba(16, 21, 34, 0.1);\n  border-radius: 28px;\n  box-shadow: var(--shadow);\n  min-height: clamp(520px, 68vw, 760px);\n  overflow: hidden;\n  position: relative;\n}\n\n.model-viewer-shell.is-fullscreen {\n  border-radius: 0;\n  min-height: 100vh;\n}\n\n.model-suspense,\n.model-loading {\n  align-items: center;\n  color: var(--ink);\n  display: flex;\n  font-weight: 800;\n  justify-content: center;\n}\n\n.model-canvas {\n  height: clamp(520px, 68vw, 760px);\n  position: relative;\n  width: 100%;\n}\n\n.model-canvas canvas {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.model-badge,\n.model-helper {\n  border-radius: 999px;\n  font-weight: 800;\n  position: absolute;\n  z-index: 3;\n}\n\n.model-badge {\n  background: linear-gradient(135deg, var(--accent), var(--gold));\n  color: #071016;\n  left: 18px;\n  padding: 9px 12px;\n  top: 18px;\n}\n\n.model-helper {\n  background: rgba(255, 255, 255, 0.88);\n  bottom: 18px;\n  color: var(--ink);\n  left: 50%;\n  padding: 10px 14px;\n  transform: translateX(-50%);\n}\n\n.model-loading {\n  background: rgba(255, 255, 255, 0.76);\n  flex-direction: column;\n  gap: 8px;\n  inset: 0;\n  position: absolute;\n  z-index: 4;\n}\n\n.model-error {\n  color: #9d3028;\n  padding: 24px;\n  text-align: center;\n}\n\n.model-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  left: 0;\n  padding: 0 18px;\n  position: absolute;\n  right: 0;\n  top: 18px;\n  z-index: 5;\n}\n\n.model-controls button {\n  align-items: center;\n  background: #05070d;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 999px;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 800;\n  justify-content: center;\n  min-height: 40px;\n  min-width: 40px;\n  padding: 0 14px;\n}\n\n.model-controls button:hover {\n  background: #151a24;\n}\n\n.section-heading {\n  margin-bottom: 26px;\n}\n\n.section-heading h2 {\n  margin: 0;\n  max-width: 780px;\n}\n\n.comparison-grid,\n.asset-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.comparison-card,\n.slider-card,\n.asset-pair {\n  border-radius: 22px;\n  padding: 18px;\n}\n\n.comparison-card span,\n.asset-pair span {\n  color: var(--muted);\n  display: block;\n  font-weight: 800;\n  margin-bottom: 12px;\n}\n\n.comparison-card img {\n  aspect-ratio: 1 / 1;\n  background: #20252c;\n  border-radius: 16px;\n  object-fit: contain;\n  width: 100%;\n}\n\n.slider-card {\n  margin: 20px 0;\n}\n\n.comparison-slider {\n  aspect-ratio: 16 / 10;\n  background: #141923;\n  border-radius: 18px;\n  overflow: hidden;\n  position: relative;\n}\n\n.comparison-slider img {\n  height: 100%;\n  object-fit: contain;\n  padding: 20px;\n  width: 100%;\n}\n\n.before-layer {\n  background: #45484b;\n  clip-path: inset(0 calc(100% - var(--split)) 0 0);\n  inset: 0;\n  position: absolute;\n}\n\n.before-label,\n.after-label {\n  background: rgba(255, 255, 255, 0.82);\n  border-radius: 999px;\n  color: var(--ink);\n  font-size: 0.8rem;\n  font-weight: 800;\n  padding: 7px 10px;\n  position: absolute;\n  top: 14px;\n}\n\n.before-label {\n  left: 14px;\n}\n\n.after-label {\n  right: 14px;\n}\n\ninput[type='range'] {\n  accent-color: var(--accent);\n  margin-top: 16px;\n  width: 100%;\n}\n\n.asset-pair div {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.asset-pair img {\n  aspect-ratio: 1 / 1;\n  background: #33373c;\n  border-radius: 14px;\n  object-fit: contain;\n  padding: 8px;\n  width: 100%;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n@media (max-width: 900px) {\n  .hero-shell,\n  .comparison-grid,\n  .asset-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .viewer360 {\n    min-height: 520px;\n  }\n}\n\n@media (max-width: 560px) {\n  .topbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .topbar img {\n    height: 70px;\n    max-width: min(320px, 100%);\n  }\n\n  .hero-shell,\n  .viewer-result,\n  .comparison-section,\n  .asset-reference {\n    padding: 38px 16px;\n  }\n\n  .upload-content {\n    min-height: 300px;\n    padding: 24px 16px;\n  }\n\n  .preview-strip {\n    align-items: flex-start;\n  }\n\n  .viewer360 {\n    min-height: 430px;\n  }\n\n  .viewer-help {\n    bottom: 14px;\n    font-size: 0.86rem;\n    max-width: calc(100% - 32px);\n    text-align: center;\n    width: max-content;\n  }\n\n  .asset-pair div {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
